import { render, staticRenderFns } from "./EditDeliveryOn.vue?vue&type=template&id=072fdbe6&scoped=true&"
import script from "./EditDeliveryOn.vue?vue&type=script&lang=js&"
export * from "./EditDeliveryOn.vue?vue&type=script&lang=js&"
import style0 from "./EditDeliveryOn.vue?vue&type=style&index=0&id=072fdbe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fdbe6",
  null
  
)

export default component.exports